import { render, staticRenderFns } from "./TraxSettingBackgroundCrudForm.vue?vue&type=template&id=23c6c918"
import script from "./TraxSettingBackgroundCrudForm.vue?vue&type=script&lang=js"
export * from "./TraxSettingBackgroundCrudForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports